import styled from "styled-components";


export const GridContainer = styled.div`
display:flex;
height: 100%;
`

export const TableTheme = {
    color: "whiteSmoke", borderColor: "#614e20ff",
    marginTop: "30px", borderTop: "2px solid #614e20ff",
    borderBottom: "2px solid #614e20ff", fontSize: "13px", borderRadius:"0px",

    '& .MuiDataGrid-columnHeader': {
        BackgroundColor: "#081019ff",
    },
    '& .MuiDataGrid-columnSeparator':{
        display:"none"
    },
    "& .MuiDataGrid-row": {
        borderColor: "#614e20ff !important",
    },

    "& .css-rtrcn9-MuiTablePagination-root": {
        color: "whiteSmoke !important",
    },

    "& .MuiButtonBase-root": {
        color: "whiteSmoke !important",
    },

    "& .MuiDataGrid-cell": {
        borderColor: "#614e20ff"
    },

    "& .MuiDataGrid-cell:focus": {
        outline: "none !important",
    }

}